var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopClipArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 274,
    viewBox: "0 0 215 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_1016",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -60,
    y: -1,
    width: 275,
    height: 275
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215 274L-59.7875 274L-59.7875 -0.310059L215 -0.310011L215 274Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6062 243.826C77.6062 260.491 64.0734 274 47.3796 274L-29.5609 274C-46.2546 274 -59.7875 260.491 -59.7875 243.826L-59.7875 166.032C-59.7875 149.368 -46.2546 135.859 -29.5609 135.859L47.3796 135.859C64.0734 135.859 77.6063 122.349 77.6063 105.685L77.6063 29.8641C77.6063 13.1997 91.1396 -0.310032 107.833 -0.310029L184.773 -0.310016C201.467 -0.310013 215 13.1998 215 29.8641L215 107.658C215 124.323 201.467 137.832 184.773 137.832L107.833 137.832C91.1395 137.832 77.6063 151.341 77.6063 168.006L77.6062 243.826Z",
    fill: "url(#paint0_linear_14_1016)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_1016",
    x1: 124.326,
    y1: 289.942,
    x2: 223.135,
    y2: -68.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714963,
    stopColor: "#1D68F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60EFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopClipArt);
export default __webpack_public_path__ + "static/media/top_clip_art.178069abd2274dd51430940911f761ea.svg";
export { ForwardRef as ReactComponent };